// ==================== EXPEDIENTES ====================
export interface Expediente {
  id: string;
  nig?: string;
  codigo_actual?: string;
  codigo_original?: string;
  tipo?: string;
  numero?: number;
  anio?: number;
  estado: string;
  justicia_gratuita: boolean;
  fecha_inicio?: string;
  fecha_encargo?: string;
  fecha_informe?: string;
  importe?: number;
  importe_iva?: number;
  cobrado: boolean;
  observaciones_generales?: string;
  created_at: string;
  updated_at: string;
  es_activo: boolean;
  nivel: string | number | null;
  proviene_de?: string;
  se_ha_convertido_en?: string;
  // Campos para relaciones con clientes y técnicos
  cliente_id?: string;
  cliente_nombre?: string;
  juzgado_id?: string;
  tecnico_id?: string;
}

// ==================== USUARIOS ====================
export interface Usuario {
  id: string;
  firebase_uid: string;
  email: string;
  display_name?: string;
  phone_number?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface UsuarioCreate {
  firebase_uid: string;
  email: string;
  display_name?: string;
  phone_number?: string;
  is_active?: boolean;
}

export interface UsuarioUpdate {
  email?: string;
  display_name?: string;
  phone_number?: string;
  is_active?: boolean;
}

// ==================== CLIENTES ====================
export interface Cliente {
  id: string;
  codigo?: string;
  nombre: string;
  tipo?: string;
  direccion?: string;
  contacto?: string;
  telefono?: string;
  email?: string;
  nif?: string;
  created_at: string;
  updated_at: string;
}

export interface ClienteCreate {
  codigo?: string;
  nombre: string;
  tipo?: string;
  direccion?: string;
  contacto?: string;
  telefono?: string;
  email?: string;
  nif?: string;
}

export interface ClienteUpdate {
  codigo?: string;
  nombre?: string;
  tipo?: string;
  direccion?: string;
  contacto?: string;
  telefono?: string;
  email?: string;
  nif?: string;
}

// ==================== TÉCNICOS ====================
export interface Tecnico {
  id: string;
  codigo?: number;
  nombre: string;
  apellidos?: string;
  dni?: string;
  especialidad?: string;
  activo: boolean;
  email?: string;
  telefono?: string;
  fecha_alta?: string;
  titulacion?: string;
  colegiado?: string;
  created_at: string;
  updated_at: string;
}

export interface TecnicoCreate {
  codigo?: number;
  nombre: string;
  apellidos?: string;
  dni?: string;
  especialidad?: string;
  activo?: boolean;
  email?: string;
  telefono?: string;
  fecha_alta?: string;
  titulacion?: string;
  colegiado?: string;
}

export interface TecnicoUpdate {
  codigo?: number;
  nombre?: string;
  apellidos?: string;
  dni?: string;
  especialidad?: string;
  activo?: boolean;
  email?: string;
  telefono?: string;
  fecha_alta?: string;
  titulacion?: string;
  colegiado?: string;
}

// ==================== ESTADÍSTICAS ====================
export interface Stats {
  total_expedientes: number;
  activos: number;
  cobrados: number;
  importe_total: number;
  total_usuarios: number;
  total_clientes: number;
  total_tecnicos_activos: number;
}

// ==================== TIPOS AUXILIARES ====================
export type ChipColor = 'success' | 'info' | 'error' | 'default' | 'primary' | 'secondary' | 'warning';

export interface DashboardModule {
  title: string;
  icon: React.ReactElement;
  color: string;
  bgColor: string;
  description: string;
  count: number;
  countLabel: string;
  actions: Array<{
    label: string;
    action: () => void;
    icon: React.ReactElement;
  }>;
}

export interface NavigationItem {
  label: string;
  path: string;
  icon: React.ReactElement;
  color: string;
}

// ==================== FORMULARIOS ====================
export interface FormField {
  name: string;
  label: string;
  type: 'text' | 'email' | 'tel' | 'number' | 'select' | 'checkbox' | 'date' | 'textarea';
  required?: boolean;
  options?: Array<{ value: string | number; label: string }>;
  placeholder?: string;
  helperText?: string;
}

export interface FormConfig {
  title: string;
  fields: FormField[];
  submitLabel: string;
  cancelLabel?: string;
}

// ==================== RESPUESTAS API ====================
export interface ApiResponse<T> {
  data: T;
  message?: string;
  success: boolean;
}

export interface ApiError {
  message: string;
  status: number;
  details?: any;
}

export interface PaginationParams {
  skip?: number;
  limit?: number;
}

export interface SearchParams extends PaginationParams {
  search?: string;
  filter?: Record<string, any>;
  sort?: {
    field: string;
    direction: 'asc' | 'desc';
  };
}

// ==================== ESTADOS DE LOADING ====================
export interface LoadingState {
  loading: boolean;
  error: string | null;
  success: boolean;
}

export interface TableState<T> {
  data: T[];
  loading: boolean;
  error: string | null;
  page: number;
  rowsPerPage: number;
  searchTerm: string;
  sortBy: string;
  sortDirection: 'asc' | 'desc';
  filters: Record<string, any>;
}

// ==================== CONSTANTES ====================
export const ESTADOS_EXPEDIENTE = [
  "Sol cobro a JZDO", 
  "En Gerencia", 
  "Pte de CLASIFICAR", 
  "COBRADO",
  "Convertido", 
  "Entregado", 
  "Pendiente", 
  "Proc Terminados"
] as const;

export const TIPOS_CLIENTE = [
  "Juzgado",
  "Despacho",
  "Particular",
  "Empresa",
  "Administración"
] as const;

export const ESPECIALIDADES_TECNICO = [
  "Arquitectura Técnica",
  "Ingeniería Industrial",
  "Arquitectura",
  "Ingeniería Civil",
  "Tasación Inmobiliaria",
  "Peritaje Judicial",
  "Valoraciones"
] as const;

export type EstadoExpediente = typeof ESTADOS_EXPEDIENTE[number];
export type TipoCliente = typeof TIPOS_CLIENTE[number];
export type EspecialidadTecnico = typeof ESPECIALIDADES_TECNICO[number];